// Forzar tema claro: eliminar cualquier clase dark
document.documentElement.classList.remove('dark');
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/mobile-only.css';
import './i18n'; // Importar configuración i18n
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
